var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.cabinet.passwordGuard.active)?_c('div',{staticClass:"absolute bg-block opacity-50 -inset-8 z-100"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }